import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="footer-info">
            <div className="footer-grid">
                <div className="footer-col">
                    <h4>PDF Converter</h4>
                    <p className="footer-tagline">
                        Free, private, client-side document tools.
                        Your files never leave your browser.
                    </p>
                </div>

                <div className="footer-col">
                    <h4>Tools</h4>
                    <ul>
                        <li><Link to="/word-to-pdf">Word to PDF</Link></li>
                        <li><Link to="/image-to-pdf">Image to PDF</Link></li>
                        <li><Link to="/compress-pdf">Compress PDF</Link></li>
                        <li><Link to="/pdf-to-image">PDF to Image</Link></li>
                        <li><Link to="/pdf-to-word">PDF to Word</Link></li>
                    </ul>
                </div>

                <div className="footer-col">
                    <h4>Company</h4>
                    <ul>
                        <li><Link to="/about">About Us</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                        <li><Link to="/blog">Blog</Link></li>
                    </ul>
                </div>

                <div className="footer-col">
                    <h4>Legal</h4>
                    <ul>
                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                        <li><Link to="/terms">Terms of Service</Link></li>
                        <li><Link to="/disclaimer">Disclaimer</Link></li>
                    </ul>
                </div>
            </div>

            <div className="footer-bottom">
                <p>&copy; {year} pdfconvertor.shop — All rights reserved.</p>
                <p className="footer-note">
                    Built with privacy in mind. Monetized by Google AdSense advertisements.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
